import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { TranslateService } from '@ngx-translate/core';
import { sentry } from 'sentry';
var DialogStopSchedulingSuggestionsComponent = /** @class */ (function () {
    function DialogStopSchedulingSuggestionsComponent(data, matDialogRef, customMessageService, translateService, maintenancesApi) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.customMessageService = customMessageService;
        this.translateService = translateService;
        this.maintenancesApi = maintenancesApi;
        this.isLoading = new EventEmitter();
    }
    DialogStopSchedulingSuggestionsComponent.prototype.ngOnInit = function () {
        this.form = this.data;
        this.maintenanceId = this.form.get('id').value;
    };
    DialogStopSchedulingSuggestionsComponent.prototype.closeDialog = function () {
        this.matDialogRef.close(true);
    };
    DialogStopSchedulingSuggestionsComponent.prototype.stopSchedulingSuggestions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenance, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading.emit(true);
                        this.matDialogRef.disableClose = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.maintenancesApi.cancelMaintenanceScheduleSuggestions(this.maintenanceId).toPromise()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.maintenancesApi.searchOne(this.maintenanceId).toPromise()];
                    case 3:
                        maintenance = _a.sent();
                        this.form.get('status').setValue(maintenance.status);
                        this.form.get('scheduleSuggestionsStatus').setValue(maintenance.scheduleSuggestionsStatus);
                        this.customMessageService.success('MAINTENANCES.STOP_SCHEDULE_SUGGESTIONS_DIALOG.SUCCESS');
                        return [3 /*break*/, 6];
                    case 4:
                        err_1 = _a.sent();
                        sentry.captureException(err_1);
                        this.customMessageService.error('MAINTENANCES.STOP_SCHEDULE_SUGGESTIONS_DIALOG.ERROR');
                        return [3 /*break*/, 6];
                    case 5:
                        this.isLoading.emit(false);
                        this.matDialogRef.disableClose = true;
                        this.closeDialog();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return DialogStopSchedulingSuggestionsComponent;
}());
export { DialogStopSchedulingSuggestionsComponent };
